import React from 'react';
import PreviewImg from '../preview_img/PreviewImg';
import cn from 'classnames';

class ReviewsItems extends React.Component {

    createMarkupThumbnail(rater_image) {
        return { __html: rater_image };
    }

    render() {
        const {
            ps,
            review,
            gigId
        } = this.props;

        const isSeller = review.get('is_seller'),
            shouldHideReview = (isSeller && !gigId) || (isSeller && ps.isMobileResponsive),
            imgSize = isSeller ? '40' : '65';

        if (shouldHideReview) {
            return null;
        }

        return (
            <li className={cn('cf', {seller: isSeller})}>
                {ps.isMobileResponsive &&
                    <div>
                        <figure>
                            <span className="user-pict-40" dangerouslySetInnerHTML={this.createMarkupThumbnail(review.get('rater_image'))}></span>
                        </figure>
                        <div className="review">
                            <a href={review.get('rater_link')}>{review.get('rater_username')}</a>
                            <span className={`star-rating-s15 rate-${review.get('value')} rf`}></span>
                            <p>{review.get('comment')}</p>
                            <p className="date">{review.get('created_at')} {i18n.t('reviews.general.ago')}</p>
                        </div>
                    </div>
                }

                {!ps.isMobileResponsive &&
                    <div>
                        <figure>
                            <span className={`user-pict-${imgSize}`} dangerouslySetInnerHTML={this.createMarkupThumbnail(review.get('rater_image'))}></span>
                        </figure>
                        {!isSeller && <PreviewImg smallImgUrl={review.get('work_sample_small')} bigImgUrl={review.get('work_sample')} ps={ps}/>}
                        <div className="review">
                            <div className="review-rating">
                                {isSeller ?
                                    <span className="review-user seller-feedback">{i18n.t('reviews.users.show.seller_feedback')}</span>
                                    :
                                    <a href={review.get('rater_link')} className="review-user">{review.get('rater_username')}</a>
                                }
                                <span className={`star-rating-s10 rate-${review.get('value')}`}></span>
                            </div>
                            <p>{review.get('comment')}</p>
                            <span className="date">{review.get('created_at')} {i18n.t('reviews.general.ago')}</span>
                        </div>
                    </div>
                }
            </li>
        );
    }
}

export default ReviewsItems;



// WEBPACK FOOTER //
// ./src/reviews/reviews_list/reviews_items/ReviewsItems.js